import { toastr } from 'react-redux-toastr'

window.axios = require('axios');
let axiosHeaders = {
    'Content-type':  'application/json',
    'Accept':        'application/json',
    'Authorization': 'Bearer testtoken',
};
window.axios.defaults.headers.common = axiosHeaders;
window.axios.interceptors.response.use(function (response) {
    if (response.status === 202) {
        document.location = response.data.redirect;
    }

    return response;
}, function (error) {
    // Do something with response error
    return Promise.reject(error);
});

export function submitNewsletter(email)
{
    return window.axios.post('/api/newsletter/', {
        email: email.trim(),
    })
    .then(response => {
        if (response.data.status == 'ok') {
            toastr.success(
                'Great News!',
                'We\'ve received your email address '+email+' and will add it to our Newsletter.'
            );

            return response;
        }

        toastr.error(
            'Uh oh',
            'There seems to have been a problem adding your email address to the Newsletter.'
        );

        return response;
    });
}

export function submitContact(fields)
{
    return window.axios.post('/api/contact/', fields)
    .then(response => {
        if (response.data.status == 'ok') {
            toastr.success(
                'Success!',
                'Your contact has been received, someone will respond to you as soon as possible. Thank you.'
            );

            return true;
        }

        toastr.error(
            'Uh oh',
            'There seems to have been a problem sending your contact.'
        );

        return false;
    });
}

export function submitMovementSignup(movementData)
{
    return window.axios.post('/api/movement/', {
        email: movementData.email.trim(),
        firstName: movementData.firstName.trim(),
        lastName: movementData.lastName.trim(),
    })
    .then(response => {
        if (response.data.status == 'ok') {
            toastr.success(
                'Success!',
                'Your email has been received, someone will be in touch with you soon regarding the FREE classes. Thank you.'
            );

            return true;
        }

        toastr.error(
            'Uh oh',
            'There seems to have been a problem sending your email.'
        );

        return false;
    });
}

export function validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
